import I18N from '@leverege/i18n';
import { Context } from '@leverege/plugin';
import { Dialogs } from '@leverege/ui-elements';
import { DataSources } from '@leverege/ui-attributes';
import { GlobalState } from '@leverege/ui-redux';
import RetrySaleJobs from './RetrySaleJobs';
const {
  tIcon,
  t
} = I18N.ns('openApi.SaleJobService.action.RetrySaleJobs');
const objectType = 'SaleJobService.saleJob';
export default {
  id: 'openApi.SaleJobService.RetrySaleJob',
  name: 'Retry Sale Job',
  layout: {
    sort: 'item.retry'
  },
  matches: [{
    use: ['contextMenu', 'mobileActionBar'],
    objectType
  }, {
    client: ['MapBoxRolloverSelectionPointer', 'ListDataViewer'],
    use: ['contextMenu', 'mobileActionBar'],
    objectType
  }],
  isPrepared: cxt => {
    const {
      clientProps: {
        objectType
      }
    } = cxt;
    const targets = Context.getTargetsOfType(cxt, objectType);
    if (!targets || targets.length === 0) {
      // nothing to do
      return true;
    }
    return targets.every(tgt => DataSources.getDelegate(tgt)?.canUpdate() != null);
  },
  prepare: cxt => {
    const {
      clientProps: {
        objectType
      }
    } = cxt;
    const targets = Context.getTargetsOfType(cxt, objectType);
    return Promise.all(targets.map(target => {
      const delegate = DataSources.getDelegate(target);
      if (delegate && delegate.canUpdate() == null) {
        return GlobalState.dispatch(delegate.requestCanAction(null, null, path => `${path}/retry`, 'post', 'retry'));
      }
      return null;
    }));
  },
  handles: cxt => {
    const {
      clientProps: {
        objectType
      }
    } = cxt;
    const targets = Context.getTargetsOfType(cxt, objectType);
    if (!targets || targets.length === 0) {
      return false;
    }
    return targets.every(tgt => DataSources.getDelegate(tgt)?.canAction(GlobalState.get(), 'retry') !== false);
  },
  appearance: ({
    context
  }) => {
    const {
      clientProps: {
        objectType,
        relationship
      }
    } = context;
    const targets = Context.getTargetsOfType(context, objectType);
    // const name = Attributes.get( 'name', objectType, target?.data )
    return {
      name: t('name', {
        count: targets.length,
        typeName: relationship.blueprint.getName(targets.length)
      }),
      icon: tIcon('icon')
    };
  },
  perform: ({
    context
  }) => {
    const {
      clientProps: {
        relationship,
        objectType,
        parentItem
      }
    } = context;
    const reloadData = context.reloadData || context.clientProps.reloadData;
    const targets = Context.getTargetsOfType(context, objectType);
    // const delegate = DataSources.getDelegate( target )

    Dialogs.show({
      component: RetrySaleJobs,
      props: {
        reloadData,
        objectType,
        relationship,
        targets,
        parentItem,
        titleIcon: tIcon('titleIcon')
      }
    });
  }
};